// extracted by mini-css-extract-plugin
module.exports = {"container":"BankInfoCard_container__TnZPy","header":"BankInfoCard_header__K1Tc_","title":"BankInfoCard_title__6oIVs"};